import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-650b0519"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "px-4 py-5 sm:px-6"
}
const _hoisted_2 = { class: "flex flex-wrap sm:flex-nowrap items-center justify-between -mt-4 -ml-4" }
const _hoisted_3 = {
  key: 0,
  class: "mt-4 ml-4"
}
const _hoisted_4 = {
  key: 0,
  class: "text-lg font-semibold leading-6 text-gray-900 m-0"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-1 text-sm leading-5 text-gray-600 mb-0"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-4 ml-4 flex-shrink-0"
}
const _hoisted_7 = {
  key: 1,
  class: "px-4 py-5 sm:px-6"
}
const _hoisted_8 = {
  key: 2,
  class: "border-t border-gray-200 bg-gray-50 px-4 py-4 sm:px-6"
}

import { computed, useSlots } from 'vue';

interface Props {
  title?: string;
  subtitle?: string;
  shadow?: 'none' | 'xs' | 'sm' | 'base' | 'lg' | 'xl';
  background?: 'white' | 'gray' | 'transparent';
  rounded?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LingoCardComponent',
  props: {
    title: { default: '' },
    subtitle: { default: '' },
    shadow: { default: 'sm' },
    background: { default: 'white' },
    rounded: { default: 'lg' }
  },
  setup(__props: any) {

const props = __props;



const slots = useSlots();

const hasHeading = computed(() => {
  return slots.title || slots.subtitle || slots.action || props.title || props.subtitle;
});

const hasHeadingContent = computed(() => {
  return slots.title || slots.subtitle || props.title || props.subtitle;
});

const shadowClass = computed(() => {
  const shadows = {
    none: '',
    xs: 'shadow-xs',
    sm: 'shadow-sm',
    base: 'shadow',
    lg: 'shadow-lg',
    xl: 'shadow-xl'
  };
  return shadows[props.shadow];
});

const backgroundClass = computed(() => {
  const backgrounds = {
    white: 'bg-white',
    gray: 'bg-gray-50',
    transparent: 'bg-transparent'
  };
  return backgrounds[props.background];
});

const roundedClass = computed(() => {
  const rounded = {
    none: 'rounded-none',
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
    '2xl': 'rounded-2xl',
    '3xl': 'rounded-3xl',
    full: 'rounded-full'
  };
  return rounded[props.rounded];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full overflow-hidden", [shadowClass.value, backgroundClass.value, roundedClass.value]])
  }, [
    (hasHeading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (hasHeadingContent.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.$slots.title || _ctx.title)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "title", {}, () => [
                          _createTextVNode(_toDisplayString(_ctx.title), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$slots.subtitle || _ctx.subtitle)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "subtitle", {}, () => [
                          _createTextVNode(_toDisplayString(_ctx.subtitle), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.$slots.action)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "action")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.default || _ctx.$slots.body)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "body", {}, () => [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})